import React from 'react';
import { ToolbarSection, ToolbarItem } from '../../editor';

export const ImageSettings = () => {
  return (
    <React.Fragment>
      <ToolbarSection title="Imagen">
        <ToolbarItem
          full={true}
          propKey="src"
          type="text"
          label="URL de la Imagen"
        />
        <ToolbarItem
          full={true}
          propKey="alt"
          type="text"
          label="Texto Alternativo"
        />
      </ToolbarSection>
      
      <ToolbarSection
        title="Dimensiones"
        props={['width', 'height']}
        summary={({ width, height }) => {
          return `${width || 'auto'} x ${height || 'auto'}`;
        }}
      >
        <ToolbarItem propKey="width" type="text" label="Ancho" />
        <ToolbarItem propKey="height" type="text" label="Alto" />
      </ToolbarSection>
    </React.Fragment>
  );
};